import { IApplicationState } from '../../types/redux';

export const selectSuggestions = (state: IApplicationState) => state.filters.suggestions;
